import { HttpClient, HttpParams } from '@angular/common/http';
import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Tuple } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { QuestionsVM, TrainingCatgoriesAndSections, TrainingCatVM, TrainingInfo, TrainingPreviewVM, TrainingSlidesVM, TrainingVM, UserListVM } from './setup-training-types.model';


@Injectable()
export class TrainingService {
  private readonly API_BASE = 'api/TrainingSetup/';
  private readonly AddMainCategory = this.API_BASE + 'AddNewMainCategory';
  private readonly EditMainCategory = this.API_BASE + 'EditMainTrainingCategory';

  private readonly AddCategory = this.API_BASE + 'AddNewCategory';
  private readonly EditCategorySection = this.API_BASE + 'EditTrainingCategorySection';
  private readonly AddSection = this.API_BASE + 'AddNewTrainingSection';
  private readonly GetTrainigCatAndSections = this.API_BASE + 'GetTrainingTypesAndSectionsDetails';
  private readonly AddTraining = this.API_BASE + 'AddNewTraining';
  private readonly OrderDownForCategories = this.API_BASE + 'OrderDownForTrainingCategories';
  private readonly OrderUpForCategories = this.API_BASE + 'OrderUpForTrainingCategories';

  private readonly OrderDownForMainCategories = this.API_BASE + 'OrderDownForMainTrainingCategories';
  private readonly OrderUpForMainCategories = this.API_BASE + 'OrderUpForMainTrainingCategories';
  
  private readonly OrderDownForSection = this.API_BASE + 'OrderDownForTrainingSection';
  private readonly OrderUpForSection = this.API_BASE + 'OrderUpForTrainingSection';
  private readonly ToggleTrainingCategory = this.API_BASE + 'ToggleTrainingCategory';
  private readonly ToggleMainTrainingCategory = this.API_BASE + 'ToggleMainTrainingCategory';
  private readonly TogglelTraining = this.API_BASE + 'TogglelTraining';


  
  private readonly ToggleTrainingSlide = this.API_BASE + 'ToggleTrainingSlide';
  private readonly ToggleTrainingQuestion = this.API_BASE + 'ToggleTrainingQuestion';

  private readonly GetTrainigCatAndSectionsForuser = this.API_BASE + 'GetTrainingTypesAndSectionsForuserDetails';
  private readonly GetUserList = this.API_BASE + 'LoadAccessibleUserList';




  private readonly EditTrainingName = this.API_BASE + 'UpdateTrainingName';
  private readonly OrderDownForTraining = this.API_BASE + 'OrderDownForTraining';
  private readonly OrderUpForTraining = this.API_BASE + 'OrderUpForTraining';

  private readonly OrderDownForTrainingQuestion = this.API_BASE + 'OrderDownForTrainingQuestion';
  private readonly OrderUpForTrainingQuestion = this.API_BASE + 'OrderUpForTrainingQuestion';

  private readonly OrderDownForSlide = this.API_BASE + 'OrderDownForSlide';
  private readonly OrderUpForSlide = this.API_BASE + 'OrderUpForSlide';

  private readonly GetTrainigTypes = this.API_BASE + 'GetTrainingTypesList';
  private readonly GetTrainigSubTypes = this.API_BASE + 'GetTrainingSubTypesList';


  private readonly GetTrainigs = this.API_BASE + 'GetTrainingList';

  private readonly GetSelectedTrainingDetails = this.API_BASE + 'GetSelectedTrainingInfo';
  private readonly GetSelectedTrainingSectionsAndQuestionInfo = this.API_BASE + 'GetSelectedTrainingSectionsAndQuestion';
  private readonly GetSelectedTrainingPreviewDetails = this.API_BASE + 'GetTrainingPreviewInfo';
  private readonly SendTrainingLink = this.API_BASE + 'SendTrainingEmail';
  private readonly CreateNewTrainingSession = this.API_BASE + 'StartTrainingForUser';


  private readonly LoadTraingToView = this.API_BASE + 'GetTrainingView';



  private readonly AddTrainingSection = this.API_BASE + 'AddNewTrainingSubSection';

  private readonly EditTrainingSectionName = this.API_BASE + 'UpdateTrainingSectionName';
  private readonly CreateNewSlide = this.API_BASE + 'AddNewSlide';
  private readonly EditSelectedSlide = this.API_BASE + 'UpdateSelectedSlide';


  private readonly GetSelectedSlideDetails = this.API_BASE + 'GetSelectedSlideInfo';
  private readonly AddTrainingQuestion = this.API_BASE + 'AddNewTrainingQuestion';
  private readonly GetSelectedQuestionDetails = this.API_BASE + 'GetSelectedQuestionInfo';

  private readonly EditTrainingQuestion = this.API_BASE + 'EditTrainingQuestion';

  private readonly GetQuestionDetailsForSection = this.API_BASE + 'GetQuestionDetailsForSection';
  private readonly UpdateTrainingSession = this.API_BASE + 'UpdateTrainingSession';




  constructor(private _http: HttpClient) { }


  public AddNewMaincategory(TrainingTypeName: string, TypeDesc: string,): Observable<boolean> {
    const options = {
      params: new HttpParams().set('TrainingTypeName', TrainingTypeName).set('TypeDesc', TypeDesc)
    };
    return this._http.get<boolean>(this.AddMainCategory, options).pipe(catchError(this.handleError));

  }

  public EditMaincategory(catId: number, CatName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('catId', catId.toString()).set('CatName', CatName)
    };
    return this._http.get<boolean>(this.EditMainCategory, options).pipe(catchError(this.handleError));

  }
  public AddNewcategory(TrainingTypeName: string, TypeDesc: string,MainParentCatId:number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('TrainingTypeName', TrainingTypeName).set('TypeDesc', TypeDesc).set('MainParentCatId', MainParentCatId.toString())
    };
    return this._http.get<boolean>(this.AddCategory, options).pipe(catchError(this.handleError));

  }

  public EditcategoryOrSection(catId: number, CatName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('catId', catId.toString()).set('CatName', CatName)
    };
    return this._http.get<boolean>(this.EditCategorySection, options).pipe(catchError(this.handleError));

  }



  public EditTraining(trainigId: number, TrainingName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('trainigId', trainigId.toString()).set('TrainingName', TrainingName)
    };
    return this._http.get<boolean>(this.EditTrainingName, options).pipe(catchError(this.handleError));

  }
  public EditTrainingSection(TraingSectionId: number, SectionName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('TraingSectionId', TraingSectionId.toString()).set('SectionName', SectionName)
    };
    return this._http.get<boolean>(this.EditTrainingSectionName, options).pipe(catchError(this.handleError));

  }

  public AddNewSection(parentCatId: number, sectionName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('parentCatId', parentCatId.toString()).set('sectionName', sectionName)
    };
    return this._http.get<boolean>(this.AddSection, options).pipe(catchError(this.handleError));

  }

  public AddNewTraining(parentCatId: number, trainingName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('parentCatId', parentCatId.toString()).set('trainingName', trainingName)
    };
    return this._http.get<boolean>(this.AddTraining, options).pipe(catchError(this.handleError));

  }

  public AddNewTrainingSection(parentCatId: number, trainingSectionName: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('parentCatId', parentCatId.toString()).set('trainingSectionName', trainingSectionName)
    };
    return this._http.get<boolean>(this.AddTrainingSection, options).pipe(catchError(this.handleError));

  }



  public GetTrainingTypesAndSections(): Observable<TrainingCatgoriesAndSections> {

    return this._http.get<TrainingCatgoriesAndSections>(this.GetTrainigCatAndSections).pipe(catchError(this.handleError));

  }

  public GetTrainingTypesAndSectionsForUser(UserId: number): Observable<TrainingCatgoriesAndSections> {
    const options = {
      params: new HttpParams().set('UserId', UserId.toString())
    };
    return this._http.get<TrainingCatgoriesAndSections>(this.GetTrainigCatAndSectionsForuser, options).pipe(catchError(this.handleError));

  }

  public LoadAccesibleUserList(): Observable<UserListVM[]> {

    return this._http.get<UserListVM[]>(this.GetUserList).pipe(catchError(this.handleError));

  }

  public GetSelectedTrainingInfo(TrainingId: number): Observable<TrainingInfo> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString())
    };
    return this._http.get<TrainingInfo>(this.GetSelectedTrainingDetails, options).pipe(catchError(this.handleError));

  }

  public GetSelectedTrainingPreviewInfo(TrainingId: number,userId:number): Observable<TrainingPreviewVM> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString()).set('userId', userId.toString())
    };
    return this._http.get<TrainingPreviewVM>(this.GetSelectedTrainingPreviewDetails, options).pipe(catchError(this.handleError));

  }
  public StartNewTrainingSession(TrainingId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString())
    };
    return this._http.get<Tuple>(this.CreateNewTrainingSession, options).pipe(catchError(this.handleError));

  }
  
  public SendTrainingEmail(TrainingId: number,userIds:number[]): Observable<boolean> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString()).set('userIds', userIds.toString())
    };
    return this._http.get<boolean>(this.SendTrainingLink, options).pipe(catchError(this.handleError));

  }

  public GetSelectedTrainingSectionAndQuestions(TrainingId: number): Observable<TrainingInfo> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString())
    };
    return this._http.get<TrainingInfo>(this.GetSelectedTrainingSectionsAndQuestionInfo, options).pipe(catchError(this.handleError));

  }
  public GetSelectedQuestionInfo(QuestionId: number): Observable<QuestionsVM> {
    const options = {
      params: new HttpParams().set('QuestionId', QuestionId.toString())
    };
    return this._http.get<QuestionsVM>(this.GetSelectedQuestionDetails, options).pipe(catchError(this.handleError));

  }
  public GetSelectedSlideInfo(SlideId: number): Observable<TrainingSlidesVM> {
    const options = {
      params: new HttpParams().set('SlideId', SlideId.toString())
    };
    return this._http.get<TrainingSlidesVM>(this.GetSelectedSlideDetails, options).pipe(catchError(this.handleError));

  }


  public GetTrainingTypes(): Observable<TrainingCatVM[]> {

    return this._http.get<TrainingCatVM[]>(this.GetTrainigTypes).pipe(catchError(this.handleError));

  }
  public GetTrainingSubTypes(): Observable<TrainingCatVM[]> {

    return this._http.get<TrainingCatVM[]>(this.GetTrainigSubTypes).pipe(catchError(this.handleError));

  }

  public GetAllTraining(): Observable<TrainingVM[]> {

    return this._http.get<TrainingVM[]>(this.GetTrainigs).pipe(catchError(this.handleError));

  }
  public OrderUp_MainCategories(Order: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString())
    };
    return this._http.get(this.OrderUpForMainCategories, options).pipe(catchError(this.handleError));

  }

  public OrderDown_MainCategories(Order: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString())
    };
    return this._http.get(this.OrderDownForMainCategories, options).pipe(catchError(this.handleError));

  }
  public OrderUp_Categories(Order: number,ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderUpForCategories, options).pipe(catchError(this.handleError));

  }

  public OrderDown_Categories(Order: number,ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderDownForCategories, options).pipe(catchError(this.handleError));

  }

  public OrderUp_Section(Order: number, ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderUpForSection, options).pipe(catchError(this.handleError));

  }

  public OrderDown_Section(Order: number, ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderDownForSection, options).pipe(catchError(this.handleError));

  }
  public OrderUp_Training(Order: number, ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderUpForTraining, options).pipe(catchError(this.handleError));

  }

  public OrderDown_Training(Order: number, ParentId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('ParentId', ParentId.toString())
    };
    return this._http.get(this.OrderDownForTraining, options).pipe(catchError(this.handleError));

  }


  public OrderUp_TrainingQuestion(Order: number, SectionId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('SectionId', SectionId.toString())
    };
    return this._http.get(this.OrderUpForTrainingQuestion, options).pipe(catchError(this.handleError));

  }

  public OrderDown_TrainingQuestion(Order: number, SectionId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('SectionId', SectionId.toString())
    };
    return this._http.get(this.OrderDownForTrainingQuestion, options).pipe(catchError(this.handleError));

  }


  public OrderUp_Slide(Order: number, SectionId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('SectionId', SectionId.toString())
    };
    return this._http.get(this.OrderUpForSlide, options).pipe(catchError(this.handleError));

  }

  public OrderDown_Slide(Order: number, SectionId: number) {
    const options = {
      params: new HttpParams().set('Order', Order.toString()).set('SectionId', SectionId.toString())
    };
    return this._http.get(this.OrderDownForSlide, options).pipe(catchError(this.handleError));

  }
  public TogglelTrainigTypesCategory(CategoryId: number, status: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('CategoryId', CategoryId.toString()).set('status', status.toString())
    };
    return this._http.get<boolean>(this.ToggleTrainingCategory, options).pipe(catchError(this.handleError));

  }

  public TogglelMainTrainigTypesCategory(CategoryId: number, status: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('CategoryId', CategoryId.toString()).set('status', status.toString())
    };
    return this._http.get<boolean>(this.ToggleMainTrainingCategory, options).pipe(catchError(this.handleError));

  }

  public TogglelTrainings(CategoryId: number, status: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('CategoryId', CategoryId.toString()).set('status', status.toString())
    };
    return this._http.get<boolean>(this.TogglelTraining, options).pipe(catchError(this.handleError));

  }
  
  
  public TogglelTrainingSlide(SlideId: number, status: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SlideId', SlideId.toString()).set('status', status.toString())
    };
    return this._http.get<boolean>(this.ToggleTrainingSlide, options).pipe(catchError(this.handleError));

  }

  public TogglelTrainingQuestion(QuestionId: number, status: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('QuestionId', QuestionId.toString()).set('status', status.toString())
    };
    return this._http.get<boolean>(this.ToggleTrainingQuestion, options).pipe(catchError(this.handleError));

  }


  public AddNewSlide(slide: TrainingSlidesVM): Observable<any> {
    return this._http.post(this.CreateNewSlide, slide).pipe(catchError(this.handleError));
  }
  public UpdateSelectedSlide(slide: TrainingSlidesVM): Observable<any> {
    return this._http.post(this.EditSelectedSlide, slide).pipe(catchError(this.handleError));
  }

  public CreateNewTrainingQuestion(question: QuestionsVM): Observable<any> {
    return this._http.post(this.AddTrainingQuestion, question).pipe(catchError(this.handleError));
  }

  public UpdateTrainingQuestion(question: QuestionsVM): Observable<any> {
    return this._http.post(this.EditTrainingQuestion, question).pipe(catchError(this.handleError));
  }


  public LoadTraining(TrainingId: number): Observable<TrainingInfo> {
    const options = {
      params: new HttpParams().set('TrainingId', TrainingId.toString())
    };
    return this._http.get<TrainingInfo>(this.LoadTraingToView, options).pipe(catchError(this.handleError));

  }

  public LoadQuestionInfForSection(SectionId: number): Observable<QuestionsVM[]> {
    const options = {
      params: new HttpParams().set('SectionId', SectionId.toString())
    };
    return this._http.get<QuestionsVM[]>(this.GetQuestionDetailsForSection, options).pipe(catchError(this.handleError));

  }

  public UpdateTrainingSessionComplete(SessionId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SessionId', SessionId.toString())
    };
    return this._http.get<boolean>(this.UpdateTrainingSession, options).pipe(catchError(this.handleError));

  }
  
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  getSelectedTrainingSlides(trainingId: number): Observable<TrainingInfo> {
     const options = {
      params: new HttpParams().set('trainingId', trainingId.toString())
    };
    return this._http.get<TrainingInfo>('api/TrainingSetup/GetSelectedTrainingSlides', options).pipe(catchError(this.handleError));
  }

}
